import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import NoMobileView from 'components/manage/common/NoMobileView';
import UploadPane from './content/UploadPane';
import ImportLoader from './content/ImportLoader';

const mq = window.matchMedia('(max-width: 768px)');

const UploadCSV = ({
  callback,
  isUploading,
  onFileSelect,
  onMappingStart,
  uploadErrors,
  flowRunId,
}) => {
  if (isUploading) return <ImportLoader />;
  // // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isMobile, setIsMobile] = useState(false);
  const handleBreakPoint = e => setIsMobile(e.matches);
  // // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    mq.addListener(handleBreakPoint);
    handleBreakPoint(mq);
    return () => mq.removeListener(handleBreakPoint);
  }, []);

  return isMobile ? (
    <NoMobileView />
  ) : (
    <UploadPane
      callback={callback}
      onMappingStart={onMappingStart}
      onFileSelect={onFileSelect}
      uploadErrors={uploadErrors}
      flowRunId={flowRunId}
    />
  );
};

UploadCSV.propTypes = {
  callback: PropTypes.func,
  onFileSelect: PropTypes.func,
  isUploading: PropTypes.bool,
  onMappingStart: PropTypes.func,
  uploadErrors: PropTypes.arrayOf(PropTypes.string),
  flowRunId: PropTypes.string,
};

export default UploadCSV;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/UploadCSV.jsx